module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/stockyana-avatar-c2110eadbae00bf346d52588b9c4ffdc.jpg";